// extracted by mini-css-extract-plugin
export var label = "_hv-0";
export var treatmentCard = "_hv-1";